module.exports = __webpack_public_path__ + "static/media/Eyes.ca345141.png";